function shopifyFormsStyle() {
	const cssFile = "//b2b.blomdahlusa.com/cdn/shop/t/2/assets/registration.css?v=75647999242541011141779473602";
	async function injectStyle(host) {
		if (!host.shadowRoot) return;
		const app = host.shadowRoot.querySelector('#app-embed');
		if (!app) return;
		if (host.shadowRoot.querySelector('#shopify-form-style')) {
			modifyShopifyForm(host);
			return;
		}
		try {
			const css = await fetch(cssFile).then((r) => r.text());
			const style = document.createElement('style');
			style.id = 'shopify-form-style';
			style.textContent = css;
			host.shadowRoot.appendChild(style);
			modifyShopifyForm(host);
		} catch (err) {
			console.error('Shopify Forms CSS load failed', err);
		}
	}

	function modifyShopifyForm(host) {
		if (!host.shadowRoot) return;
		const form = host.shadowRoot.querySelector('form');
		if (!form) return;
		const registrationHeading = form.querySelector('h2');
		if (registrationHeading) {
			registrationHeading.style.display = 'none';
		}
		form.querySelectorAll('legend').forEach((legend) => {
			if (legend.textContent.trim().toLowerCase().includes('address')) {
				legend.style.display = 'none';
			}
		});
		const countryButton = form.querySelector('[aria-controls="shipping_address_country-selector-dropdown"]');
		if (countryButton && !countryButton.dataset.usSelected) {
			const countryInput = form.querySelector('#shipping_address_country');
			const text = countryButton.querySelector('._selectToggleText_12thd_25');
			if (text) {
				text.textContent = 'United States';
			}
			if (countryInput) {
				countryInput.value = 'United States';
				countryInput.dispatchEvent(new Event('input', {
					bubbles: true
				}));
				countryInput.dispatchEvent(new Event('change', {
					bubbles: true
				}));
			}
			countryButton.dispatchEvent(new Event('input', {
				bubbles: true
			}));
			countryButton.dispatchEvent(new Event('change', {
				bubbles: true
			}));
			countryButton.dataset.usSelected = 'true';
			setTimeout(() => {
				const countrySelector = countryButton.closest('._nonMultineFieldLine_exnrn_11');
				if (countrySelector) {
					countrySelector.style.display = 'none';
				}
			}, 500);
		}
		form.querySelectorAll('.phone-country-selector').forEach((el) => {
			el.style.display = 'none';
		});
		const phoneInput = form.querySelector('#shipping_address_phone');
		if (phoneInput && !phoneInput.dataset.phoneHandler) {
			const sanitizePhone = () => {
				phoneInput.value = phoneInput.value.replace(/^\+\d+\s*/, '');
			};
			phoneInput.addEventListener('input', sanitizePhone);
			phoneInput.dataset.phoneHandler = 'true';
		}
		const emailField = form.querySelector('#email')?.closest('._formFieldContainer_1mxsl_5');
		const firstNameRow = form.querySelector('#shipping_address_first_name')?.closest('._multiFieldLine_exnrn_1');
		if (emailField && firstNameRow && !emailField.dataset.moved) {
			const emailWrapper = document.createElement('div');
			emailWrapper.className = '_fieldContainer_exnrn_16';
			emailWrapper.appendChild(emailField);
			const firstNameContainer = form.querySelector('#shipping_address_first_name')?.closest('._fieldContainer_exnrn_16');
			if (firstNameContainer) {
				firstNameContainer.after(emailWrapper);
			}
			emailField.dataset.moved = 'true';
		}
		const lastNameContainer = form.querySelector('#shipping_address_last_name')?.closest('._fieldContainer_exnrn_16');
		if (lastNameContainer) {
			lastNameContainer.style.display = 'none';
		}
		const companyField = form.querySelector('#company_name')?.closest('._formFieldContainer_1mxsl_5 ');
		if (companyField) {
			companyField.style.display = 'none';
		}
		const shippingCompanyInput = form.querySelector('#shipping_address_recipient');
		const shippingCompanyField = shippingCompanyInput?.closest('._nonMultineFieldLine_exnrn_11');
		if (shippingCompanyInput && shippingCompanyField) {
			shippingCompanyField.style.display = '';
			const label = shippingCompanyField.querySelector('label');
			if (label) {
				label.classList.add('custom-hidden-label');
				label.classList.add('required_field');
			}
			shippingCompanyInput.placeholder = 'Company Name *';
		}
		const fields = form.querySelectorAll('._formFieldContainer_1mxsl_5');
		fields.forEach((field) => {
			const input = field.querySelector('input, textarea');
			const label = field.querySelector('label');
			if (!input || !label) return;
			let labelText = label.textContent.trim();
			if (input.id === 'shipping_address_first_name') {
				labelText = 'Name';
			}
			const requiredInputs = ['email', 'shipping_address_first_name', 'shipping_address_recipient', 'shipping_address_address1', 'shipping_address_city', 'shipping_address_zip', 'shipping_address_phone', ];
			if (requiredInputs.includes(input.id)) {
				labelText += ' *';
			}
			input.placeholder = labelText;
			label.classList.add('custom-hidden-label');
		});
		const requiredFields = ['#label-shipping_address_first_name', '#label-email', '#label-shipping_address_recipient', '#label-shipping_address_address1', '#label-shipping_address_city', '#label-shipping_address_phone', '#label-shipping_address_zip', ];
		requiredFields.forEach((selector) => {
			const label = form.querySelector(selector);
			if (label && !label.classList.contains('required_field')) {
				label.classList.add('required_field');
			}
		});
		const zipInput = form.querySelector('#shipping_address_zip');
		if (zipInput) {
			zipInput.required = true;
		}
		const firstNameInput = form.querySelector('#shipping_address_first_name');
		if (firstNameInput) {
			firstNameInput.required = true;
		}
		const shippingCompanyRequired = form.querySelector('#shipping_address_recipient');
		if (shippingCompanyRequired) {
			shippingCompanyRequired.required = true;
		}
		const stateButton = form.querySelector('[aria-controls="shipping_address_zone-selector-dropdown"]');
		if (stateButton) {
			stateButton.setAttribute('data-required', 'true');
		}
		const stateContainer = stateButton?.closest('._selectContainer_12thd_6');
		if (stateContainer && !stateContainer.classList.contains('required_field')) {
			stateContainer.classList.add('required_field');
		}
		const hiddenCompanyInput = form.querySelector('#company_name');
		if (shippingCompanyInput && hiddenCompanyInput && !shippingCompanyInput.dataset.companySync) {
			const syncCompanyFields = () => {
				hiddenCompanyInput.value = shippingCompanyInput.value;
				hiddenCompanyInput.dispatchEvent(new Event('input', {
					bubbles: true
				}));
				hiddenCompanyInput.dispatchEvent(new Event('change', {
					bubbles: true
				}));
			};
			shippingCompanyInput.addEventListener('input', syncCompanyFields);
			shippingCompanyInput.addEventListener('change', syncCompanyFields);
			shippingCompanyInput.dataset.companySync = 'true';
		}
		if (!form.dataset.nativeErrorHandler) {
			form.addEventListener('submit', () => {
				requestAnimationFrame(() => {
					const emailInput = form.querySelector('#email');
					const zipInput = form.querySelector('#shipping_address_zip');
					const phoneInput = form.querySelector('#shipping_address_phone');
					const firstNameInput = form.querySelector('#shipping_address_first_name');
					const shippingCompanyInput = form.querySelector('#shipping_address_recipient');
					const emailField = emailInput?.closest('._formFieldContainer_1mxsl_5');
					const zipField = zipInput?.closest('._formFieldContainer_1mxsl_5');
					const phoneField = phoneInput?.closest('._formFieldContainer_1mxsl_5');
					const firstNameField = firstNameInput?.closest('._formFieldContainer_1mxsl_5');
					const shippingCompanyField = shippingCompanyInput?.closest('._formFieldContainer_1mxsl_5');
					if (emailInput && !emailInput.value.trim() && emailField) {
						emailField.classList.add('_withError_1mxsl_17');
					}
					if (zipInput && !zipInput.value.trim() && zipField) {
						zipField.classList.add('_withError_1mxsl_17');
					}
					if (phoneInput && !phoneInput.value.trim() && phoneField) {
						phoneField.classList.add('_withError_1mxsl_17');
					}
					if (firstNameInput && !firstNameInput.value.trim() && firstNameField) {
						firstNameField.classList.add('_withError_1mxsl_17');
					}
					if (shippingCompanyInput && !shippingCompanyInput.value.trim() && shippingCompanyField) {
						shippingCompanyField.classList.add('_withError_1mxsl_17');
					}
					if (stateButton && stateButton.innerText.trim().toLowerCase() === 'state' && stateContainer) {
						stateContainer.classList.add('_withError_1mxsl_17');
					}
					const outputs = form.querySelectorAll('output._formError_1mxsl_21');
					outputs.forEach((output) => {
						const text = output.textContent.toLowerCase();
						let targetField = null;
						if (text.includes('email')) {
							targetField = emailField;
						} else if (text.includes('zip') || text.includes('postal')) {
							targetField = zipField;
						} else if (text.includes('phone')) {
							targetField = phoneField;
						} else if (text.includes('name')) {
							targetField = firstNameField;
						} else if (text.includes('company')) {
							targetField = shippingCompanyField;
						} else if (text.includes('state') || text.includes('province')) {
							targetField = stateContainer;
						} else {
							const prev = output.previousElementSibling;
							if (prev && prev.classList.contains('_withError_1mxsl_17')) {
								targetField = prev;
							}
						}
						if (targetField && !targetField.contains(output)) {
							targetField.appendChild(output);
						}
					});
					[{
						input: firstNameInput,
						field: firstNameField
					}, {
						input: phoneInput,
						field: phoneField
					}, {
						input: zipInput,
						field: zipField
					}, {
						input: shippingCompanyInput,
						field: shippingCompanyField
					}].forEach((item) => {
						if (item.input && !item.input.value.trim() && item.field && !item.field.querySelector('output._formError_1mxsl_21')) {
							const output = document.createElement('output');
							output.className = '_formError_1mxsl_21';
							output.setAttribute('role', 'alert');
							output.textContent = 'Field is required';
							item.field.appendChild(output);
						}
					});
					if (stateButton && stateButton.innerText.trim().toLowerCase() === 'state' && stateContainer && !stateContainer.querySelector('output._formError_1mxsl_21')) {
						const output = document.createElement('output');
						output.className = '_formError_1mxsl_21';
						output.setAttribute('role', 'alert');
						output.textContent = 'Field is required';
						stateContainer.appendChild(output);
					}
				});
			});
			form.dataset.nativeErrorHandler = 'true';
		}
		['#shipping_address_first_name', '#shipping_address_phone', '#shipping_address_zip', '#shipping_address_recipient'].forEach((selector) => {
			const input = form.querySelector(selector);
			if (!input || input.dataset.liveValidation) return;
			input.addEventListener('input', () => {
				const field = input.closest('._formFieldContainer_1mxsl_5');
				if (!field) return;
				if (input.value.trim()) {
					field.classList.remove('_withError_1mxsl_17');
					const output = field.querySelector('output._formError_1mxsl_21');
					if (output) {
						output.style.display = 'none';
					}
				} else {
					const output = field.querySelector('output._formError_1mxsl_21');
					if (output) {
						output.style.display = '';
					}
				}
			});
			input.dataset.liveValidation = 'true';
		});
		if (stateButton && !stateButton.dataset.liveValidation) {
			stateButton.addEventListener('click', () => {
				requestAnimationFrame(() => {
					if (stateButton.innerText.trim().toLowerCase() !== 'state') {
						stateContainer?.classList.remove('_withError_1mxsl_17');
						const output = stateContainer?.querySelector('output._formError_1mxsl_21');
						if (output) {
							output.style.display = 'none';
						}
					}
				});
			});
			stateButton.dataset.liveValidation = 'true';
		}
	}

	function observeEmbed(el) {
		injectStyle(el);
		if (!el.shadowRoot) return;
		const observer = new MutationObserver(() => {
			injectStyle(el);
			modifyShopifyForm(el);
		});
		observer.observe(el.shadowRoot, {
			childList: true,
			subtree: true,
		});
	}

	function init() {
		document.querySelectorAll('shopify-forms-embed').forEach(observeEmbed);
	}
	init();
	const bodyObserver = new MutationObserver(init);
	bodyObserver.observe(document.body, {
		childList: true,
		subtree: true,
	});
}
document.addEventListener('DOMContentLoaded', shopifyFormsStyle);
document.addEventListener('shopify:section:load', shopifyFormsStyle);